import React from 'react';
import cssClasses from './empty.css';

const Empty = () => {
    return <div className={cssClasses.empty}><i className="fa fa-exclamation-triangle" aria-hidden="true" /><span>No transactions to display...</span></div>
}

export default Empty;



// WEBPACK FOOTER //
// ./src/components/DataTable/Body/Empty/empty.js